import { post } from "../base.ehq.model";
import { serialize } from "./submit-email.serializer";
import { deserialize } from "../base.serializer";

export const submitRegisteredEmail = async (
  token: string,
  baseUrl: string,
  body: unknown
) => {
  try {
    const queryPath = `${baseUrl}/forgot_password_email`;
    const serializedBody = serialize(body);

    const res = await post(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
